// Utility function to sanitize input for URLs and href attributes to prevent XSS and injection attacks
export const sanitizeInput = (input: string | undefined | null): string => {
  if (!input) return "";
  // Remove potentially dangerous characters while preserving URL-safe characters
  return String(input).replace(/[<>"'\s]/g, "");
};
